"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSession = void 0;
// eslint-disable-next-line import/no-unresolved
const client_1 = require("@side/identity-token/client");
const jwt_decode_1 = require("jwt-decode");
const react_1 = require("next-auth/react");
const react_2 = require("react");
const get_cached_session_store_1 = require("../utils/get-cached-session-store");
const handle_token_refresh_error_1 = require("../utils/handle-token-refresh-error");
const session_has_changed_1 = require("../utils/session-has-changed");
const useSession = (options) => {
    const { allowExpiredToken } = options ?? {};
    const session = (0, react_1.useSession)(options);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Will add session dependency in next major
    return (0, react_2.useMemo)(() => {
        if (session.data) {
            const adminScopes = (0, jwt_decode_1.jwtDecode)(session.data.accessToken).adminScopes || [];
            const hasScopesFn = (expectedScopes) => {
                return (0, client_1.hasScopes)(adminScopes, expectedScopes);
            };
            session.data.hasScopes = hasScopesFn;
            // Update the cached session if it has changed
            if (!get_cached_session_store_1.cachedSessionStore.cachedSession ||
                (0, session_has_changed_1.sessionHasChanged)(session.data, get_cached_session_store_1.cachedSessionStore.cachedSession)) {
                get_cached_session_store_1.cachedSessionStore.cachedSession = { ...session.data };
            }
        }
        else {
            get_cached_session_store_1.cachedSessionStore.cachedSession = null;
        }
        // handleTokenRefreshError will return null for the session data
        // if there is a token refresh error
        if (session.data && (0, handle_token_refresh_error_1.hasRefreshTokenError)(session.data)) {
            const data = (0, handle_token_refresh_error_1.handleTokenRefreshError)(session.data, allowExpiredToken);
            // The return type of useSession would be SessionContextValue<R>, but since we are re-writing
            // the value of session.status it no longer conforms to that types conditional logic.
            const status = 
            // if handleTokenRefreshError returns null, but next-auth says it is authenticated,
            // we need to treat the session as unauthenticated until the logout page is loaded
            session.status === 'authenticated' && !data
                ? 'unauthenticated'
                : session.status;
            return { status, data, update: session.update };
        }
        return { ...session };
    }, [session.status, session.data, session.update, allowExpiredToken]);
};
exports.useSession = useSession;
